import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPagesBySlug } from "../../services/apiService";
import useSlug from "../SlugComp";
import SEO from "../Seo";
import parse from "html-react-parser";

// Blog content map - can be expanded with more blog posts
const blogContentMap = {
  "global-capability-center": {
    id: 1,
    title: "Best IT Consulting Company in Hyderabad | TechProjects",
    category: "IT Consulting",
    image:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=1200",
    date: "July 23, 2026",
    author: "TechProjects",
    readTime: "10 minutes",
    excerpt:
      "Looking for the best IT consulting company in Hyderabad? Learn how to choose the right technology partner and discover how Tech projects deliver cloud, AI, cybersecurity, and digital transformation solutions.",
    content: [
      {
        type: "heading2",
        text: "How to Choose the Best IT Consulting Company in Hyderabad for Your Business",
      },
      {
        type: "paragraph",
        text: 'Hyderabad has become one of Indias leading technology hubs, attracting startups, enterprises,  <a href="https://techprojects.com/services/gcc" class="text-blue-600 hover:text-blue-800">Global Capability Centers in Hyderabad</a> (GCCs), and multinational corporations. As organizations accelerate digital transformation, choosing the right IT consulting partner has become a strategic decision that impacts business growth, innovation, and operational efficiency.',},
  
    {
        type: "paragraph",
        text: 'With dozens of <a href="https://techprojects.com/" class="text-blue-600 hover:text-blue-800"> IT consulting companies in Hyderabad</a>, India, selecting the right partner can be challenging. This guide explains the key factors to evaluate and why TechProjects is a trusted technology consulting partner for organizations looking to modernize their business.',},
    {
        type: "heading2",
        text: "Why Businesses Need IT Consulting Services",
      },
      {
        type: "paragraph",
        text: "Technology evolves rapidly, and businesses need experienced consultants to stay competitive. A reliable IT consulting company helps organizations:"
    },
    {
        type: "bulletList",
        items: [
          "Develop a digital transformation roadmap",
          "Modernize legacy applications",
          "Migrate workloads to the cloud",
          "Strengthen cybersecurity",
          "Implement AI and automation",
          "Improve business processes",
          "Build scalable enterprise applications",
          "Reduce operational costs",
         
        ],
      },
      {
        type: "paragraph",
        text: "Whether you're a startup or a global enterprise, the right consulting partner delivers measurable business outcomes rather than simply implementing technology."
    },
      {
        type: "heading2",
        text: "Key Factors to Consider When Choosing an IT Consulting Company",
      },
      {
        type: "heading3",
        text: "1. Industry Experience",
      },
      {
        type: "paragraph",
        text: "Choose a consulting firm with experience across industries such as healthcare, banking, manufacturing, retail, telecom, logistics, and public sector organizations. Industry knowledge enables faster implementation and better business outcomes.",
      },
      {
        type: "heading3",
        text: "2. Technology Expertise",
      },
      {
        type: "paragraph",
        text: "The best IT consulting companies in Hyderabad offer expertise in:",
      },
      {
        type: "bulletList",
        items: [
           "Artificial Intelligence (AI)",
           "Machine Learning",
           "Data Analytics",
           "Cybersecurity",
           "ERP Solutions",
           "Digital Engineering",
           "Platform Engineering",
           "DevOps",
           "Enterprise Application Development"
         
        ],
      },
      {
        type: "paragraph",
        text: "A broad technology portfolio ensures your business can scale without changing partners.",
      },
      {
        type: "heading3",
        text: "3. End-to-End Consulting Services",
      },
      {
        type: "paragraph",
        text: "Look for companies that provide complete consulting support, including:",
      },
      {
        type: "bulletList",
        items: [
           "IT Strategy",
           "Technology Assessment",
           "Solution Architecture",
           "Software Development",
           "Cloud Migration",
           "Infrastructure Modernization",
           "Managed Services",
           "Ongoing Support"
         
        ],
      },
      {
        type: "paragraph",
        text: "An end-to-end partner simplifies project execution and reduces operational complexity.",
      },
      {
        type: "heading3",
        text: "4. Global Delivery Capabilities",
      },
      {
        type: "paragraph",
        text: "If your organization serves international markets, select a consulting company with experience supporting clients across North America, Europe, the Middle East, and Asia-Pacific.",
      },
      {
        type: "paragraph",
        text: "Global delivery experience ensures compliance, scalability, and efficient collaboration across time zones.",
      },
      {
        type: "heading3",
        text: "5. Security and Compliance",
      },
      {
        type: "paragraph",
        text: "Data protection is essential. Ensure your IT consulting partner follows industry best practices for:",
      },
      {
        type: "bulletList",
        items: [
           "Cybersecurity",
           "Risk Management",
           "Compliance",
           "Identity Management",
           "Secure Cloud Infrastructure",
           "Disaster Recovery"
         
        ],
      },
      {
        type: "paragraph",
        text: "Security should be integrated into every stage of the project lifecycle.",
      },
      {
        type: "heading2",
        text: "Why TechProjects Is a Preferred IT Consulting Partner",
      },
      {
        type: "paragraph",
        text: 'Among the leading IT consulting companies in Hyderabad, India, <a href="https://techprojects.com/about" class="text-blue-600 hover:text-blue-800"> TechProjects </a> provides comprehensive technology consulting services designed to help businesses accelerate innovation and digital transformation.',},
      {
        type: "paragraph",
        text: "TechProjects combines deep technical expertise with business-focused consulting to deliver scalable, future-ready solutions.",
      },
      {
        type: "heading3",
        text: "Core Capabilities",
      },
      {
        type: "bulletList",
        items: [
          "IT Consulting",
          "Digital Transformation",
          "Cloud Consulting",
          "AI & Data Solutions",
          "Cybersecurity Consulting",
          "Platform Engineering",
          "Global Capability Center (GCC) Enablement",
          "Enterprise Application Development",
          "Managed IT Services",
          "Technology Staffing Solutions"
        ],
      },
      {
        type: "paragraph",
        text: "By aligning technology investments with business objectives, TechProjects helps organizations improve efficiency, reduce costs, and achieve sustainable growth.",
      },
      {
        type: "heading2",
        text: "Questions to Ask Before Hiring an IT Consulting Company",
      },
      {
        type: "paragraph",
        text: "Before selecting an IT consulting partner, ask:",
      },
      {
        type: "bulletList",
        items: [
          "What industries do you specialize in?",
          "Can you provide client success stories?",
          "What cloud platforms do you support?",
          "How do you approach cybersecurity?",
          "What is your project management methodology?",
          "Do you provide post-implementation support?",
          "Can your team scale with future business requirements?",
          "What KPIs do you use to measure project success?"
        ],
      },
      {
        type: "paragraph",
        text: "These questions help identify a partner capable of delivering long-term value.",
      },
      {
        type: "heading2",
        text: "Benefits of Choosing the Right IT Consulting Company",
      },
      {
        type: "paragraph",
        text: "Working with an experienced IT consulting partner enables organizations to:",
      },
      {
        type: "bulletList",
        items: [
          "Accelerate digital transformation",
          "Improve operational efficiency",
          "Increase business agility",
          "Reduce technology risks",
          "Optimize IT spending",
          "Enhance customer experience",
          "Scale faster with modern cloud technologies",
          "Strengthen cybersecurity posture"
        ],
      },
      
      {
        type: "heading2",
        text: "Conclusion",
      },
      {
        type: "paragraph",
        text: "Selecting the right IT consulting company is one of the most important technology decisions an organization can make. Rather than focusing only on cost, businesses should evaluate technical expertise, industry experience, security capabilities, innovation, and long-term partnership potential.",
      },
      {
        type: "paragraph",
        text: "For organizations seeking reliable IT consulting companies in Hyderabad, India, TechProjects offers comprehensive consulting, digital transformation, cloud, AI, cybersecurity, and enterprise technology solutions that help businesses achieve measurable results and sustainable growth.",
      },
      {
        type: "heading2",
        text: "FAQS :",
      },
      {
        type: "heading3",
        text: "1. How do I choose the best IT consulting company in Hyderabad? :",
      },
      {
        type: "paragraph",
        text: "Choose an IT consulting company based on its industry experience, technical expertise, client success stories, service offerings, security standards, and ability to deliver scalable solutions. A trusted partner like TechProjects provides end-to-end IT consulting, cloud, AI, cybersecurity, and digital transformation services.",
      },
      {
        type: "heading3",
        text: "2. What services do IT consulting companies in Hyderabad offer?",
      },
      {
        type: "paragraph",
        text: "IT consulting companies in Hyderabad typically offer digital transformation, cloud consulting, cybersecurity, AI and data analytics, ERP consulting, application development, platform engineering, managed IT services, and technology staffing.",
      },
      {
        type: "heading3",
        text: "3. Why should businesses hire an IT consulting company in Hyderabad?",
      },
      {
        type: "paragraph",
        text: "Hyderabad is home to a strong technology ecosystem, skilled IT professionals, and global enterprises. Hiring an IT consulting company in Hyderabad gives businesses access to expert guidance, cost-effective solutions, and innovative technologies that drive growth.",
      },
      {
        type: "heading3",
        text: "4. Which industries benefit from IT consulting services?",
      },
      {
        type: "paragraph",
        text: "IT consulting services help organizations across healthcare, banking and financial services, manufacturing, retail, logistics, education, telecommunications, and government sectors improve efficiency, security, and digital capabilities.",
      },
      {
        type: "heading3",
        text: "5. Why is TechProjects a trusted IT consulting company in Hyderabad?",
      },
      {
        type: "paragraph",
        text: "TechProjects helps businesses accelerate digital transformation through IT consulting, cloud solutions, AI, cybersecurity, platform engineering, Global Capability Center (GCC) services, and managed IT solutions. Its business-focused approach enables organizations to innovate, scale, and achieve measurable results.",
      },

    ],
    relatedArticles: [
      {
        title: "Cloud Migration Best Practices",
        image:
          "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=400",
        category: "Cloud",
        slug: "cloud-migration-best-practices",
      },
      {
        title: "React Performance Optimization",
        image:
          "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400",
        category: "React",
        slug: "react-performance-optimization",
      },
      {
        title: "DevOps Automation with CI/CD",
        image:
          "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=400",
        category: "DevOps",
        slug: "devops-automation-cicd",
      },
    ],
  },
};

function BlogDetail() {
  let slug = useSlug();
  const [metaData, setMetaData] = useState({});
  // useEffect(() => {
  //   const fetchMetaData = async () => {
  //     const data = await getPagesBySlug(slug);
  //     setMetaData(data?.meta || {});
  //   };
  //   fetchMetaData();
  // }, [slug]);
  // slug = useParams();
 useEffect(() => {
  const fetchData = async () => {
      const data = await getPagesBySlug(slug.toLowerCase());
      setMetaData(data.data);
    };

      fetchData();},[slug]);
  // console.log(slug+ "test")
  const navigate = useNavigate();
  const blog = blogContentMap["global-capability-center"];

  if (!blog) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Blog post not found
          </h2>
          <p className="text-gray-600 mb-8">
            The article you're looking for doesn't exist.
          </p>
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
            onClick={() => navigate("/blogs")}
          >
            Back to Blog
          </button>
        </div>
      </div>
    );
  }

  const renderContent = () => {
    return blog.content.map((section, index) => {
      switch (section.type) {
        case "heading2":
          return (
            <h2
              key={index}
              className="text-3xl font-bold text-gray-900 mt-8 mb-4"
            >
              {parse(section.text)}
            </h2>
          );
        case "heading3":
          return (
            <h3
              key={index}
              className="text-2xl font-bold text-blue-600 mt-6 mb-3"
            >
              {parse(section.text)}
            </h3>
          );
        case "paragraph":
          return (
            <p key={index} className="text-gray-700 leading-relaxed mb-4">
              {parse(section.text)}
            </p>
          );
        case "bulletList":
          return (
            <ul key={index} className="list-disc list-inside space-y-2 mb-4 text-gray-700">
              {section.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          );
        default:
          return null;
      }
    });
  };

  return (
    <>
      {/* Hero Section with Image */}
      <section
        className="relative h-96 md:h-[500px] bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('${blog.image}')`,
        }}
      >
        <div className="text-center max-w-3xl px-4">
          <span className="inline-block bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
            {blog.category}
          </span>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            {blog.title}
          </h1>
          <p className="text-lg text-gray-100">
            Looking for the best IT consulting company in Hyderabad? Learn how to choose the right technology partner and discover how Tech projects deliver cloud, AI, cybersecurity, and digital transformation solutions.
          </p>
        </div>
      </section>

      {/* Article Content */}
      <SEO {...metaData} />
      <section className="py-12 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Article Meta */}
          <div className="mb-8 pb-8 border-b border-gray-200 flex justify-between items-center flex-wrap gap-4">
            <div>
              <p className="text-gray-600 mb-1">By {blog.author}</p>
              <p className="text-gray-600">{blog.date}</p>
            </div>
            <div>
              <span className="text-sm text-gray-600">
                Estimated read time: {blog.readTime}
              </span>
            </div>
          </div>

          {/* Article Body */}
          <div className="prose prose-lg max-w-none">
            {renderContent()}

            {/* Call to Action */}
            {/* <div className="mt-8 p-6 bg-blue-50 border-l-4 border-blue-600 rounded-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Ready to Transform Your Development Process?
              </h3>
              <p className="text-gray-700 mb-4">
                TechProjects specializes in AI-driven software solutions and
                digital transformation. Our experts can help you integrate AI
                into your development workflows efficiently and securely.
              </p>
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-colors duration-200"
                onClick={() => {
                  window.location.href = "/Contact";
                }}
              >
                Get Started Today
              </button>
            </div> */}
          </div>

          {/* Share Section */}
          <div className="mt-8 pt-8 border-t border-gray-200 flex justify-between items-center flex-wrap gap-4">
            <div>
              <p className="text-gray-700 font-semibold">Share this article:</p>
            </div>
            <div className="flex gap-3">
              <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                Facebook
              </button>
              <button className="bg-blue-400 hover:bg-blue-500 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                Twitter
              </button>
              <button className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-200">
                LinkedIn
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Related Articles */}
      {/* <section className="py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Related Articles
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {blog.relatedArticles.map((article, index) => (
              <div
                key={index}
                className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
                onClick={() => navigate(`/blog/${article.slug}`)}
              >
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="p-6">
                  <span className="inline-block bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-xs font-semibold mb-3">
                    {article.category}
                  </span>
                  <h3 className="font-bold text-gray-900">{article.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Back to Blog Button */}
      <section className="py-8 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-200"
            onClick={() => navigate("/blogs")}
          >
            ← Back to Blog
          </button>
        </div>
      </section>
    </>
  );
}

export default BlogDetail;
